import React, { useCallback, useEffect, useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Card, CardContent, Grid, Typography, Avatar } from '@material-ui/core';
import PersonIcon from '@material-ui/icons/Person';
import api from 'services/api';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%'
  },
  content: {
    alignItems: 'center',
    display: 'flex'
  },
  title: {
    fontWeight: 700
  },
  avatar: {
    backgroundColor: theme.palette.success.main,
    height: 56,
    width: 56
  },
  icon: {
    height: 32,
    width: 32
  },
  difference: {
    marginTop: theme.spacing(2),
    display: 'flex',
    alignItems: 'center'
  },
  differenceIcon: {
    color: theme.palette.success.main
  },
  differenceValue: {
    color: theme.palette.success.main,
    marginRight: theme.spacing(1)
  }
}));

const OwnerCard = props => {
  const { className, farmID, fieldID, ...rest } = props;
  const [field, setField] = useState(null);

  const classes = useStyles();

  const getField = useCallback(async () => {
    if(!farmID) {
      return;
    }

    try {
      const response = await api.get(`farms/${farmID}/fields/${fieldID}`);

      setField(response.data);
    } catch (err) {
      console.log(err);
    }
  }, [farmID, fieldID]);

  useEffect(() => {
    getField();
  }, [getField]);

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardContent>
        <Grid
          container
          justify="space-between"
        >
          <Grid item>
            <Typography
              className={classes.title}
              color="textSecondary"
              gutterBottom
              variant="body2"
            >
              NÚMERO DO TALHÃO
            </Typography>
            <Typography variant="h3">{field?.name}</Typography>
          </Grid>
          <Grid item>
            <Avatar className={classes.avatar}>
              <PersonIcon className={classes.icon} />
            </Avatar>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

OwnerCard.propTypes = {
  className: PropTypes.string
};

export default OwnerCard;
